import { Page } from '@/core/architecture'

import { ConsoleAccountSettingTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleAccountSetting Page
 * Implemented as a practical sample.
 */
export const ConsoleAccountSetting: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleAccountSettingTemplate state={state} {...actions} />
}
